export const changeTab = (type, index) => dispatch => {
    dispatch({
        type,
        index,
    })
}
